<div class="container">
    <div class="wrapper-md">
        <app-breadcrumbs [items]="[{ url: '/my-roles', text: 'myRoles_title' }]"></app-breadcrumbs>

        <header class="content-header">
            <h1>{{'myRoles_title' | translate}}</h1>
        </header>

        <div class="content-desc">{{'myRoles_description' | translate}}</div>

        <app-alert level="info" *ngIf="isReady && isEmpty">{{'myRoles_empty' | translate}}</app-alert>

        <div class="row" *ngIf="isReady && !isEmpty">
            <div class="col-lg-4 col-md-12">
                <div class="form-field fc-icons-start">
                    <i class="fi fi-rs-search fc-icon-start"></i>
                    <input class="form-control"
                           name="fitlerTerm"
                           [(ngModel)]="filterTerm"
                           (input)="filter()"
                           [placeholder]="'search' | translate"
                           maxlength="50">
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="form-field">
                    <app-select [options]="typeOptions"
                                name="filterTypes"
                                [multiple]="true"
                                [placeholder]="'myRoles_type' | translate"
                                [displayFn]="typeDisplayFn"
                                [icon]="'fi fi-rs-filter'"
                                [(ngModel)]="filterTypes"
                                (selectionChange)="filter()">
                    </app-select>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="form-field">
                    <app-select [options]="sortOptions"
                                name="sortOptions"
                                [required]="true"
                                [placeholder]="'myRoles_sort' | translate"
                                [displayProperty]="'name'"
                                [valueProperty]="'key'"
                                [icon]="'fi fi-rs-sort-alt'"
                                [(ngModel)]="sortKey"
                                (selectionChange)="sort()">
                    </app-select>
                </div>
            </div>
        </div>

        <div class="roles" *ngIf="isReady && !isEmpty">
            <div *ngFor="let n of items" class="role">
                <div class="role-inner">
                    <div class="icon">
                        <i class="fi fi-rs-globe"></i>
                    </div>
                    <div class="resource">{{n.Resource}}</div>
                    <div class="desc">{{n.Description}}</div>
                    <div class="meta">
                        <div class="type">{{n.Type}}</div>
                        <div class="name">{{n.Name}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
